<template>
    <div>
      <!-- <general-top-bar :title="$t('gestiune.settings')"></general-top-bar> -->
        <div id="outer-container">
            <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
                <div class="card-content">
                    <div class="clearfix row pad-lf-10 pad-rg-10">
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isGestiuni }"
                          @click="openGestiuni"
                        >{{$t('gestiune.gestiuni')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isSeries }"
                          @click="openSeries"
                        >{{$t('invoice.seriesDocument')}}</a>
                        <!-- <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isUsers }"
                          @click="openUsers"
                        >{{$t('gestiune.users')}}</a> -->
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isCategories }"
                          @click="openCategories"
                        >{{$t('gestiune.categoriesSettings')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isOperation }"
                          @click="openOperation"
                        >{{$t('gestiune.operations')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isOrderErrors }"
                          @click="openOrderErrors"
                        >{{$t('gestiune.orderErrors')}}</a>
                        <!-- <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isBankAccounts }"
                          @click="openBanckAccounts"
                        >{{$t('gestiune.bankAccounts')}}</a> -->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isGestiuni">
          <div class="action-buttons">
            <div class="left-buttons"></div>
            <div class="right-buttons">
              <button
                class="btn add mar-rt-10"
                @click.prevent="openGestiuneModal"
                :title="$t('general.add') + ' ' + $t('settingUsers.single')"
              >
                <img src="/static/img/icons/add.png" />
                {{$t('gestiune.addManagment')}}
              </button>
            </div>
          </div>

          <template v-if="locations.length">
            <div
              v-for="group in gestiuniGroupedByVatNumber"
              :key="group.vat"
              class="location-group"
            >
              <template v-if="group.gestiuni.length">
                <p class="location-label">
                  {{ group.label }} — VAT: {{ group.vat }}
                </p>

                <div class="card mar-to-15">
                  <div class="card-content">
                    <div class="data-table">
                      <el-table :data="group.gestiuni">
                        <el-table-column :label="$t('gestiune.numeGestiune')" prop="name">
                          <template slot-scope="scope">
                            {{ scope.row.name }}
                            <span
                              v-if="isDefaultForLocation(scope.row._id, scope.row.externalLocationId)"
                              class="default-label"
                            >
                              Default
                            </span>
                          </template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.category')" prop="categorie">
                          <template slot-scope="scope">{{ scope.row.categorie }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.tipGestiune')" prop="gestiune_type">
                          <template slot-scope="scope">{{ scope.row.gestiune_type }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.workPoint')" prop="nume_punct_de_lucru">
                          <template slot-scope="scope">{{ scope.row.nume_punct_de_lucru }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.adresaPunctLucru')" prop="adresa_punct_de_lucru">
                          <template slot-scope="scope">{{ scope.row.adresa_punct_de_lucru }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.numeGestionar')" prop="gestionar">
                          <template slot-scope="scope">{{ scope.row.gestionar }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('gestiune.codContabil')" prop="cod_contabil">
                          <template slot-scope="scope">{{ scope.row.cod_contabil }}</template>
                        </el-table-column>

                        <el-table-column
                          prop="id"
                          :label="$t('marketingOffers.actions')"
                          width="120"
                        >
                          <template slot-scope="{ row }">
                            <el-dropdown trigger="click" placement="bottom-end">
                              <!-- Trigger: săgeată jos cu border violet -->
                              <span class="arrow-box">
                                &#9662; <!-- săgeata jos -->
                              </span>
                              <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                                <el-dropdown-item @click.native="editRowGestiune(row)">
                                  {{ $t('general.edit') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="handleDeleteGestiune(row)"
                                  style="color: red; font-weight: bold;">
                                  {{ $t('general.delete') }}
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </template>
                        </el-table-column>

                      </el-table>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-if="!gestiuniGroupedByVatNumber.some(g => g.gestiuni.length)">
            <p class="mar-to-20 text-center">
              {{ $t('gestiune.noGestiuni') }}
            </p>
          </template>
        </div>
        <div v-if="isSeries">
          <div class="action-buttons">
            <div class="left-buttons"></div>
            <div class="right-buttons">
              <button class="btn add mar-rt-10" @click.prevent="openSeriesModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                <img src="/static/img/icons/add.png" />
                {{$t('invoice.addSeries')}}
              </button>
            </div>
          </div>

          <div v-for="group in groupedSeriesByVat" :key="group.vat" class="vat-group">
            <p class="location-label">
              {{ group.locationsNames }} — VAT: {{ group.vat }}
            </p>

            <div class="card mar-to-15">
              <div class="card-content">
                <div class="data-table">
                  <el-table :data="group.series">
                    <el-table-column :label="$t('invoice.type')" prop="tip">
                      <template slot-scope="scope">{{ scope.row.tip }}</template>
                    </el-table-column>

                    <el-table-column :label="$t('invoice.series')" prop="series">
                      <template slot-scope="scope">{{ scope.row.series }}</template>
                    </el-table-column>

                    <el-table-column :label="$t('invoice.startNumber')" prop="startNumber">
                      <template slot-scope="scope">{{ scope.row.startNumber }}</template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.currentNumber')" prop="currentNumber">
                      <template slot-scope="scope">{{ scope.row.currentNumber }}</template>
                    </el-table-column>

                    <el-table-column
                      prop="id"
                      :label="$t('marketingOffers.actions')"
                      width="120"
                    >
                      <template slot-scope="{ row }">
                        <el-dropdown trigger="click" placement="bottom-end">
                          <!-- Trigger: săgeată jos cu border violet -->
                          <span class="arrow-box">
                            &#9662;
                          </span>
                          <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                            <el-dropdown-item @click.native="handleDeleteSeries(row._id)"
                              style="color: red; font-weight: bold;">
                              {{ $t('general.delete') }}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!groupedSeriesByVat.length" class="no-series-message text-center mar-to-20">
            <p>{{ $t('gestiune.noSeries') }}</p>
          </div>
        </div>
        <div v-if="isCategories">
          <div class="action-buttons">
            <div class="left-buttons">
            </div>
          </div>
          <div class="card mar-to-15">
            <div class="card-content">
              <div class="data-table">
                <el-table :data="tableDataCategories">
                  <el-table-column :label="$t('gestiune.categorii')" prop="category">
                    <template slot-scope="scope">
                      {{ scope.row.category }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('gestiune.contContabil')" prop="account">
                    <template slot-scope="scope">
                      {{ scope.row.account }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isOperation" style="display: flex; gap: 5px;">
          <div class="card mar-to-15 col-md-6">
            <div class="card-content">
              <div class="mar-b-15">
                <h5>Pornește vânzările</h5>
                <div class="info-text">
                  Prin selectarea locației și a datei, se pornesc bonurile fiscale din Taptasty în gestiune,
                  iar mișcările de stoc vor apărea în raport.
                </div>
              </div>
              <!-- Select locație -->
              <div class="form-group">
                <label>{{ $t('gestiune.locatie') }}</label>
                <select v-model="selectedLocation" class="form-control">
                  <option value="" disabled>Selectează locația (Punct de lucru)</option>
                  <option
                    v-for="location in locations"
                    :key="location.id"
                    :value="location"
                  >
                    {{ location.name }}{{ location.gestiune_start_sync_order ? ' (Start: ' + location.gestiune_start_sync_order + ')' : '' }}
                  </option>
                </select>

                <!-- Afișare data start cu stil -->
                <div v-if="selectedLocation && selectedLocation.gestiune_start_sync_order" style="margin-top: 8px;">
                  <span style="font-weight: 500; background-color: #28a745; color: white; padding: 3px 7px; border-radius: 4px;">
                    Start: {{ selectedLocation.gestiune_start_sync_order }}
                  </span>
                </div>
              </div>

              <!-- Select dată -->
              <div class="form-group mar-to-10">
                <label>{{ $t('gestiune.dataStart') }}</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="selectedDate"
                  :max="maxDate"
                  :min="minDate"
                />
              </div>

              <!-- Buton start vânzări -->
              <div class="mar-to-15 d-flex">
                <button
                  class="btn btn-icon btn-success mar-rt-10 save"
                  :disabled="!selectedLocation || !selectedDate"
                  @click="toggleSales(true, selectedLocation.inv_fiscal_code)"
                >
                  {{ selectedLocation && selectedLocation.gestiune_start_sync_order ? 'Modifică vânzările' : 'Pornește vânzările' }}
                </button>

                <a
                  class="btn delete mar-rt-10"
                  :title="$t('general.delete')"
                  :class="{ disabled: !selectedLocation || !selectedLocation.gestiune_start_sync_order }"
                  @click="toggleSales(false)"
                >
                  <img src="/static/img/icons/icon-close.png" />
                   Oprește vânzările
                </a>
              </div>

            </div>
          </div>
          <div class="card mar-to-15 col-md-6">
            <div class="card-content">

              <div class="mar-b-15">
                <h5>Export Nomenclator</h5>
                <div class="info-text">
                  Alege CIF-ul pentru care dorești să exporti catalogul
                  de produse în format CSV.
                </div>
              </div>

              <div class="form-group">
                <label>CIF</label>
                <select class="form-control" v-model="selectedVatExport">
                  <option value="">Selectează CIF-ul</option>
                  <option
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :value="group.vat"
                  >
                    {{ getVatOptionLabel(group) }}
                  </option>
                </select>
              </div>

              <!-- Buton export -->
              <div class="mar-to-15">
                <button
                  class="btn btn-icon btn-info"
                  :disabled="!selectedVatExport"
                  @click="exportNomenclator"
                >
                  Exportă Nomenclator
                </button>
              </div>

            </div>
          </div>
          <div class="card mar-to-15 col-md-6">
            <div class="card-content">
              <div class="mar-b-15">
                <h5>Activare SPV (ANAF)</h5>
                <div class="info-text">
                  Alege CIF-ul și activează conexiunea SPV pentru transmiterea documentelor fiscale către ANAF.
                </div>
              </div>

              <div class="form-group">
                <label>CIF</label>
                <select class="form-control" v-model="selectedVatSpv" @change="fetchSpvStatus">
                  <option value="">Selectează CIF-ul</option>
                  <option
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :value="group.vat"
                  >
                    {{ getVatOptionLabel(group) }}
                  </option>
                </select>
              </div>

              <div v-if="selectedVatSpv && spvStatusLoaded" class="mar-b-10">

               <div v-if="spvStatus.hasToken" class="badge badge-success">
                  Token existent
                </div>

                <div v-else class="badge badge-warning">
                  Fără token SPV
                </div>

                <div v-if="spvStatus.hasToken" class="spv-expire-box">
                  <small>
                    Expiră la:
                    {{ formatDate(spvStatus.expiresAt) }}
                  </small>
                </div>
              </div>
              <div class="mar-to-15">
                <button
                  type="button"
                  class="btn btn-icon btn-primary spv-enroll-btn"
                  :disabled="!selectedVatSpv"
                  @click="openSpvEnroll"
                >
                  {{ spvStatus.hasToken ? 'Administrează token' : 'Activează token' }}
                </button>
                <p v-if="!selectedVatSpv" class="spv-enroll-hint">
                  Selectează un CIF pentru a continua.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isOrderErrors">
          <ManagementOrderErrors :locations="locations" />
        </div>
        <div v-if="isBankAccounts">
          <div class="action-buttons">
            <div class="left-buttons">
            </div>
            <div class="right-buttons">
                <button class="btn add mar-rt-10"  @click.prevent="openBankModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                  <img src="/static/img/icons/add.png">
                  Adaugă Cont Bancar
                </button>
            </div>
          </div>
          <div class="card mar-to-15">
            <div class="card-content">
              <div class="data-table">
                <el-table :data="bankAccounts" style="width: 100%">
                  <el-table-column prop="iban" label="IBAN"></el-table-column>
                  <el-table-column prop="bank" label="Banca"></el-table-column>
                  <el-table-column prop="currency" label="Moneda"></el-table-column>
                  <el-table-column prop="swift" label="SWIFT"></el-table-column>
                  <el-table-column label="Acțiuni">
                    <template slot-scope="{ row }">
                      <a class="btn delete mar-rt-10"
                        :title="$t('general.delete')"
                        @click="deleteBankAccount(row)">
                        <img src="/static/img/icons/icon-close.png">
                        {{$t('general.delete')}}
                      </a>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="isUsers">
          <ManagementUsers />
        </div> -->
        <vmodal name="bankAccountModal" height="auto" width="800" v-model="showBankModal">
          <div class="card">
            <div class="card-content">
              <div class="modal-header">
                <p>Adaugă Cont Bancar</p>
              </div>
              <div class="modal-body">
                <form class="clearfix row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>IBAN</label>
                      <input type="text" class="form-control" v-model="newAccount.iban" placeholder="Introduceți IBAN" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Banca</label>
                      <input type="text" class="form-control" v-model="newAccount.bank" placeholder="Introduceți banca" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Moneda</label>
                      <select class="form-control" v-model="newAccount.currency">
                        <option value="RON">RON</option>
                        <option value="EUR">EUR</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>SWIFT</label>
                      <input type="text" class="form-control" v-model="newAccount.swift" placeholder="Introduceți SWIFT" />
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <div class="button-group">
                  <button @click.prevent="addBankAccount" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
                  <a @click="closeBankModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
                </div>
              </div>
            </div>
          </div>
        </vmodal>
        <vmodal name="addGestiuneModal" height="auto" width="800" v-model="showGestiuneModal">
          <div class="card">
              <div class="card-content">
                  <div class="modal-header">
                      <p>{{ $t('gestiune.addManagment') }}</p>
                  </div>
                  <div class="modal-body">
                      <div class="row mt-3">
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>{{ $t('gestiune.numeGestiune') }}*</label>
                                  <input type="text" :placeholder="$t('gestiune.numeGestiune')" v-model="gestiune" v-validate="modelValidate.gestiune" class="form-control"/>
                              </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Categoria *</label>
                              <select v-model="typeGestion" class="form-control" v-validate="modelValidate.typeGestion">
                                <option disabled value="">Selectează Categoria</option>

                                <option
                                  v-for="(item, index) in tableDataCategories"
                                  :key="index"
                                  :value="item.category"
                                >
                                  {{ item.category }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>{{ $t('gestiune.numeGestionar') }}</label>
                                  <input type="text" :placeholder="$t('gestiune.numeGestionar')" v-model="administrator" class="form-control"/>
                              </div>
                          </div>

                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>{{ $t('gestiune.codGestiune') }}</label>
                                  <input type="text" :placeholder="$t('gestiune.codGestiune')" v-model="codGestiune" class="form-control"/>
                              </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ $t('gestiune.locatie') }}</label>
                              <select v-model="selectedLocation" class="form-control">
                                <option value="" disabled>Selectează locatia (Punct de lucru)</option>
                                <option
                                  v-for="location in locations"
                                  :key="location.id"
                                  :value="location"
                                >
                                  {{ location.name }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>{{ $t('gestiune.adresaPunctLucru') }}</label>
                                  <input type="text" :placeholder="$t('gestiune.adresaPunctLucru')" v-model="selectedLocation.street" class="form-control" disabled/>
                              </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ $t('gestiune.codContabil') }}</label>
                              <input
                                type="text"
                                v-model="codContabil"
                                :placeholder="$t('gestiune.codContabil')"
                                class="form-control"
                              />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ $t('gestiune.analitic') }}</label>
                              <input
                                type="text"
                                v-model="analitic"
                                :placeholder="$t('gestiune.analitic')"
                                :disabled="!codContabil"
                                class="form-control"
                              />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Depozit</label>
                              <select v-model="tipDepozit" class="form-control">
                                <option disabled value="">Selectează tipul</option>
                                <option value="Depozit">Da</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-6" style="position:relative; top: 40px;">
                            <div class="form-group">
                              <label>
                                <input type="checkbox" v-model="isDefaultGestiune" />
                                {{ $t('gestiune.default') }}
                              </label>
                            </div>
                          </div>
                      </div>
                  </div>

                  <div class="modal-footer">
                    <div class="button-group">
                      <a @click="closeGestiuneModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
                      <button @click.prevent="validate" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
                    </div>
                  </div>
              </div>
          </div>
        </vmodal>

        <ManagementSeriesAdd
          :locations="locations"
          :grouped-locations="groupedLocations"
          @getSeries="getSeries"
        />
    </div>
</template>

  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    import ManagementUsers from 'src/components/Dashboard/Views/Management/ManagementUsers.vue'
    import ManagementSeriesAdd from 'src/components/Dashboard/Views/Management/ManagementSeriesAdd.vue'
    import ManagementOrderErrors from 'src/components/Dashboard/Views/Management/ManagementOrderErrors.vue'
    import swal from 'sweetalert2'

    function getLocalDateTimeString () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    }


    export default {
      components: {
        // GeneralTopBar,
        ManagementUsers,
        ManagementSeriesAdd,
        ManagementOrderErrors
      },
      props: {
        locations: {
          type: Array,
          required: true
        },
        groupedLocations: {
          type: Array,
          required: true
        }
      },
      data () {
        return {
          codContabil: '',
          analitic: '',
          typeGestion: '',
          selectedLocationSeries: '',
          selectedDate: getLocalDateTimeString(),
          editGestiuneId: null,
          spvStatus: {},
          spvStatusLoaded: false,
          editSeriesId: null,
          showBankModal: false,
          bankAccounts: [],
          tableData: [],
          isGestiuni: true,
          tipDepozit: '',
          isCategories: false,
          isOperation: false,
          isOrderErrors: false,
          isSeries: false,
          isUsers: false,
          isBankAccounts: false,
          codGestiune: '',
          showGestiuneModal: false,
          showSeriesModal: false,
          isDefaultGestiune: false,
          gestiune: '',
          tipGestiune: 'Cantitativ Valoric',
          adresaPunctLucru: '',
          administrator: '',
          selectedLocation: '',
          modelValidate: {
            gestiune: { required: true },
            typeGestion: { required: true }
          },
          newAccount: {
            iban: '',
            bank: '',
            currency: 'RON',
            swift: ''
          },
          tableDataCategories: [
            { category: 'Marfa', account: 371 },
            { category: 'Materii prime', account: 301 },
            { category: 'Materiale consumabile', account: 302 },
            { category: 'Semifabricate (Reteta)', account: 341 },
            { category: 'Produs finit (Reteta)', account: 345 },
            { category: 'Produs rezidual', account: 346 },
            { category: 'Ambalaje', account: 381 },
            { category: 'Obiecte de inventar', account: 303 }
          ],
          tableDataSeries: [],
          series: '',
          startNumber: null,
          endNumber: null,
          tip: '',
          selectedVatExport: '',
          selectedVatSpv: ''
        }
      },
      computed: {
        spvEnrollUrl () {
          if (!this.companyID || !this.selectedVatSpv) return '#'

          let base = `${process.env.API_BASE_URL_GESTIUNE}:4443/spv_enroll.html?externalCompanyId=${this.companyID}&vatNumber=${encodeURIComponent(this.selectedVatSpv)}`

          if (this.spvStatus.hasToken && this.spvStatus.stateNonce) {
            base += `&state_nonce=${this.spvStatus.stateNonce}`
          }

          return base
        },
        gestiuniGroupedByVatNumber () {
          const groups = {}

          this.tableData.forEach(gestiune => {
            const vat = gestiune.vatNumber || 'no-vat'
            const locationName = this.getLocationName(gestiune.externalLocationId || 'unknown')

            if (!groups[vat]) {
              groups[vat] = {
                locationNames: new Set(),
                gestiuni: []
              }
            }
            if (locationName !== '') {
              groups[vat].locationNames.add(locationName)
              groups[vat].gestiuni.push(gestiune)
            }
          })

          return Object.entries(groups).map(([vat, group]) => ({
            vat,
            label: Array.from(group.locationNames).join(', '),
            gestiuni: group.gestiuni
          }))
        },
        groupedSeriesByVat () {
          if (!this.groupedLocations || !this.tableDataSeries) return []

          return this.groupedLocations.map(group => {
            // Caută toate seriile care au vatNumber egal cu vat-ul grupului
            const seriesForGroup = this.tableDataSeries.filter(serie =>
              serie.vatNumber === group.vat
            )

            const locationsNames = group.locations.map(loc => loc.name).join(', ')

            return {
              vat: group.vat,
              locationsNames,
              series: seriesForGroup
            }
          }).filter(group => group.series.length > 0)
        },
        maxDate () {
          return getLocalDateTimeString()
        },
        minDate () {
          const date = new Date()
          date.setDate(date.getDate() - 30)
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          const hours = String(date.getHours()).padStart(2, '0')
          const minutes = String(date.getMinutes()).padStart(2, '0')
          return `${year}-${month}-${day}T${hours}:${minutes}`
        }
      },
      watch: {
        selectedLocation (newLoc) {
          if (newLoc && newLoc.gestiune_start_sync_order) {
            this.selectedDate = newLoc.gestiune_start_sync_order.replace(' ', 'T').slice(0, 16)
          } else {
            this.selectedDate = getLocalDateTimeString()
          }
        },
        codContabil (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.analitic = ''
          }
        }
      },
      created () {
        this.companyID = this.$session.get('selectedCompany')

        this.fetchGestiuni()
        this.getSeries()
      },
      methods: {
        async fetchSpvStatus () {
          if (!this.companyID) return

          const vatNumber = this.selectedVatSpv
          if (!vatNumber) {
            this.spvStatus = {}
            this.spvStatusLoaded = false
            return
          }

          try {
            const params = new URLSearchParams({
              externalCompanyId: this.companyID,
              vatNumber
            })

            const res = await fetch(
              `${process.env.API_BASE_URL_GESTIUNE}:4443/auth/anaf/status?${params.toString()}`
            )

            const data = await res.json()

            this.spvStatus = data
            this.spvStatusLoaded = true
          } catch (err) {
            console.error('Eroare SPV status:', err)
            this.spvStatusLoaded = false
          }
        },
        getVatOptionLabel (group) {
          const count = group && group.locations ? group.locations.length : 0
          const locationsLabel = count === 1 ? '1 locație' : `${count} locații`
          return `${group.vat} — ${locationsLabel}`
        },
        openSpvEnroll () {
          if (!this.selectedVatSpv || !this.spvEnrollUrl || this.spvEnrollUrl === '#') return
          window.open(this.spvEnrollUrl, '_blank')
        },
        formatDate (timestamp) {
          if (!timestamp) return '-'
          return new Date(timestamp).toLocaleString()
        },
        getLocationName (locationId) {
          const loc = this.locations.find(l => l.true_id === locationId)
          return loc ? loc.name : ''
        },
        isDefaultForLocation (gestiuneId, locationId) {
          const loc = this.locations.find(l => l.true_id === locationId)
          return loc.gestiune_id_default === gestiuneId
        },
        validate () {
          this.$validator.validateAll().then(isValid => {
            if (isValid) { this.saveGestiune() }
          })
        },
        openGestiuni () {
          this.isGestiuni = true
          this.isCategories = false
          this.isOperation = false
          this.isOrderErrors = false
          this.isSeries = false
          this.isUsers = false
          this.isBankAccounts = false
        },
        openCategories () {
          this.isSeries = false
          this.isGestiuni = false
          this.isCategories = true
          this.isUsers = false
          this.isBankAccounts = false
          this.isOperation = false
          this.isOrderErrors = false
        },
        openSeries () {
          this.isSeries = true
          this.isGestiuni = false
          this.isCategories = false
          this.isUsers = false
          this.isBankAccounts = false
          this.isOperation = false
          this.isOrderErrors = false

          this.getSeries()
        },
        openBanckAccounts () {
          this.isSeries = false
          this.isGestiuni = false
          this.isCategories = false
          this.isUsers = false
          this.isBankAccounts = true
          this.isOperation = false
          this.isOrderErrors = false
        },
        openUsers () {
          this.isSeries = false
          this.isGestiuni = false
          this.isCategories = false
          this.isUsers = true
          this.isBankAccounts = false
          this.isOperation = false
          this.isOrderErrors = false
        },
        openOperation () {
          this.isSeries = false
          this.isGestiuni = false
          this.isCategories = false
          this.isUsers = false
          this.isBankAccounts = false
          this.isOperation = true
          this.isOrderErrors = false
        },
        openOrderErrors () {
          this.isSeries = false
          this.isGestiuni = false
          this.isCategories = false
          this.isUsers = false
          this.isBankAccounts = false
          this.isOperation = false
          this.isOrderErrors = true
        },
        openGestiuneModal () {
          this.gestiune = ''
          this.codGestiune = ''
          this.tipGestiune = 'Cantitativ Valoric'
          this.selectedLocation = ''
          this.administrator = ''
          this.isDefaultGestiune = false
          this.typeGestion = ''
          this.codContabil = ''
          this.analitic = ''

          this.$modal.show('addGestiuneModal')
        },
        openBankModal () {
          this.$modal.show('bankAccountModal')
        },
        closeBankModal () {
          this.$modal.hide('bankAccountModal')
        },
        closeGestiuneModal () {
          this.$modal.hide('addGestiuneModal')
        },
        openSeriesModal () {
          this.editSeriesId = null
          this.tip = ''
          this.series = ''
          this.startNumber = ''
          this.endNumber = ''

          this.$modal.show('addSeriesModal')
        },
        closeSeriesModal () {
          this.$modal.hide('addSeriesModal')
        },
        async fetchGestiuni () {
          if (!this.companyID) {
            console.error('Missing VAT number for fetching management data.')
            return
          }
          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
            const data = await response.json()

            if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
              this.tableData = data.gestiuni
            } else {
              swal({
                title: 'Error!',
                text: 'Nu s-a primit un array valid de la server.',
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              })
            }
          } catch (error) {
            swal({
              title: 'Error!',
              text: `Request failed: ${error.message}`,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
            console.error('Error fetching management data:', error)
          }
        },
        editRowGestiune (row) {
          this.editGestiuneId = row._id // salvează id-ul dacă e editare
          this.gestiune = row.name || ''
          this.codGestiune = row.cod_gestiune || ''
          const location = this.locations.find(loc => loc.true_id === row.externalLocationId)
          this.selectedLocation = location
            ? { ...location, street: row.adresa_punct_de_lucru }
            : ''
          this.administrator = row.gestionar || ''
          this.typeGestion = row.categorie || ''
          this.tipDepozit = row.is_depozit ? 'Depozit' : ''
          this.tipGestiune = row.gestiune_type || ''
          this.vatNumber = row.vatNumber || ''
          this.isDefaultGestiune = false
          this.codContabil = row.cod_contabil || ''
          this.analitic = row.analitic || ''
          this.$modal.show('addGestiuneModal')
        },
        editRowSeries (row) {
          this.editSeriesId = row._id || row.id || null  // id-ul seriei
          this.tip = row.tip || ''
          this.series = row.series || ''
          this.startNumber = row.startNumber || null
          this.currentNumber = row.currentNumber || null
          this.showSeriesModal = true

          this.$modal.show('addSeriesModal')
        },
        async exportNomenclator () {
          try {
            if (!this.selectedVatExport) {
              swal({
                icon: 'error',
                title: 'Selectează CIF-ul',
                text: 'Trebuie să alegi un CIF pentru a filtra catalogul.'
              })
              return
            }

            // Swal loading
            swal({
              title: 'Se exportă catalogul...',
              text: 'Așteaptă câteva secunde',
              icon: 'info',
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading()
              }
            })

            // Conform cerințelor API
            const externalCompanyId = this.companyID || null
            const vatNumber = this.selectedVatExport || null

            // Validare cerută în documentație
            if (!externalCompanyId && !vatNumber) {
              swal({
                icon: 'error',
                title: 'Parametri lipsă',
                text: 'Trebuie să existe externalCompanyId sau vatNumber.'
              })
              return
            }

            // Query parameters corect conform API
            const params = new URLSearchParams()

            if (externalCompanyId) params.append('externalCompanyId', externalCompanyId)
            if (vatNumber) params.append('vatNumber', vatNumber)

            const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator-export?${params.toString()}`

            // Request GET (server trimite CSV)
            const response = await fetch(url)

            if (response.status === 400) {
              swal({
                icon: 'error',
                title: 'Cerere invalidă',
                text: 'Lipsește externalCompanyId sau vatNumber.'
              })
              return
            }

            if (!response.ok) {
              throw new Error('Eroare la generarea exportului.')
            }

            // Preluare fișier CSV
            const blob = await response.blob()
            const downloadUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = downloadUrl
            a.download = `nomenclator_${Date.now()}.csv`
            a.click()

            window.URL.revokeObjectURL(downloadUrl)

            swal({
              icon: 'success',
              title: 'Export finalizat',
              text: 'Fișierul CSV a fost descărcat.'
            })
          } catch (error) {
            console.error(error)
            swal({
              icon: 'error',
              title: 'Eroare la export',
              text: error.message || 'A apărut o eroare.'
            })
          }
        },
        async saveGestiune () {
          try {
            if (!this.selectedLocation.inv_fiscal_code) {
              swal({
                icon: 'warning',
                title: 'Lipsă cod fiscal',
                text: 'Pentru locația selectată nu este setat codul VAT. Te rugăm să completezi codul VAT în pagina de locații înainte de a salva gestiunea.',
                timer: 3000,
                showConfirmButton: true
              })
              return
            }
            // Verifică și creează compania dacă nu există
            await this.checkCompany()

            const existingGestiuniOnLocation = this.tableData.filter(g =>
              g.externalLocationId === this.selectedLocation.true_id &&
              (!this.gestiune.id || g._id !== this.gestiune.id)
            )

            if (existingGestiuniOnLocation.length === 0) {
              this.isDefaultGestiune = true
            }

            const gestiuneData = {
              name: this.gestiune,
              cod_gestiune: this.codGestiune,
              externalCompanyId: this.companyID,
              externalLocationId: this.selectedLocation.true_id,
              gestiune_type: this.tipGestiune,
              is_depozit: this.tipDepozit === 'Depozit',
              nume_punct_de_lucru: this.selectedLocation.name,
              adresa_punct_de_lucru: this.selectedLocation.street,
              gestionar: this.administrator,
              categorie: this.typeGestion,
              cod_contabil: this.codContabil,
              analitic: this.analitic,
              vatNumber: this.selectedLocation.inv_fiscal_code
            }

            if (this.editGestiuneId && this.gestiune.id) {
              gestiuneData.id = this.gestiune.id
            }

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiune`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(gestiuneData)
            })

            const responseData = await response.json()

            if (response.ok) {
              swal({
                title: 'Succes!',
                text: 'Datele de gestiune au fost salvate cu succes.',
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              })
              if (this.isDefaultGestiune) {
                this.modifyGestiune({
                  gestiuneCompanyId: responseData.externalCompanyId,
                  gestiuneIdDefault: responseData._id,
                  companyId: this.companyID,
                  locationId: responseData.externalLocationId
                }, () => {
                  this.$modal.hide('addGestiuneModal')
                  this.fetchGestiuni()
                  this.$emit('fetchLocation')
                })
              } else {
                // Dacă nu e default, continuă normal
                this.$modal.hide('addGestiuneModal')
                this.fetchGestiuni()
                this.$emit('fetchLocation')
              }
            } else {
              swal({
                title: 'Error!',
                text: responseData.message || 'An error occurred while saving the management data.',
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              })
            }
          } catch (error) {
            swal({
              title: 'Error!',
              text: `Request failed: ${error.message}`,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
            console.error('Error saving management data:', error)
          }
        },
        async modifyGestiune ({ gestiuneCompanyId, gestiuneIdDefault, companyId, locationId }, callback = null) {
          const dataToSend = {
            gestiune_company_id: gestiuneCompanyId,
            gestiune_id_default: gestiuneIdDefault,
            company_id: companyId,
            location_id: locationId,
            token: this.$session.get('token')
          }

          this.apiRequest('/gestiune/modify-gestiune', 'POST', dataToSend, (response) => {
            if (!response || response.error || response.status === false) {
              swal({
                title: 'Eroare!',
                text: response.message || 'Modificarea gestiunii a eșuat.',
                type: 'error',
                timer: 3000,
                showConfirmButton: false
              })
            }
            if (callback) {
              callback(response)
            }
          })
        },
        async toggleSales (isStart, vatNumber) {
          try {
            if (isStart) {
              await this.getSeries(vatNumber)
              const requiredTypes = [
                'NIR',
                'Bon casare',
                'Bon de transfer',
                'Bon consum',
                'Bon de productie',
                'Inventar',
                'Invoice',
                'Proforma',
                'Aviz',
                'Order'
              ].map(t => t.toLowerCase().replace(/\s+/g, '_'))

              const missingTypes = requiredTypes.filter(normalizedType =>
                !this.tableDataSeries.some(serie =>
                  serie.tip.toLowerCase().replace(/\s+/g, '_') === normalizedType
                )
              )

              if (missingTypes.length > 0) {
                const missingText = missingTypes
                  .map(t => `- ${t.replace(/_/g, ' ')}`)
                  .join('<br>')

                swal({
                  icon: 'error',
                  title: 'Nu se pot porni vânzările',
                  html: `Lipsesc seriile următoare:<br>${missingText}<br><br>Creează-le mai întâi din tabul "Serii documente".`
                })
                return
              }
            }

            // 4. Formatează data
            const formattedDate = this.selectedDate.replace('T', ' ') + ':00'

            // 5. Pregătește obiectul pentru request
            const dataToSend = {
              location_id: this.selectedLocation.true_id,
              company_id: this.companyID,
              gestiune_start_sync_order: isStart ? formattedDate : null,
              token: this.$session.get('token')
            }

            // 6. Requestul propriu-zis
            this.apiRequest('/gestiune/modify-start-sync-order', 'POST', dataToSend, (response) => {
              if (response && response.status === true) {
                swal({
                  icon: 'success',
                  title: isStart
                    ? 'Vânzările au fost pornite!'
                    : 'Vânzările au fost oprite!'
                }).then(() => {
                  if (isStart) {
                    swal({
                      icon: 'warning',
                      title: 'Atenție!',
                      text: 'Asigură-te că toate produsele care necesită rețetă au rețetele complet definite și că pe această locație există serii active pentru documentele „Bon de producție” și „Bon de consum”. Dacă acestea lipsesc, le poți crea din tabul „Serii documente”. În lipsa lor, vânzările pot fi afectate.'
                    })
                  }
                })

                this.$emit('fetchLocation')
              } else {
                let errorMsg = 'A apărut o problemă.'
                if (response && response.errors && response.errors.length > 0) {
                  errorMsg = response.errors.join(', ')
                }
                swal({
                  icon: 'error',
                  title: isStart
                    ? 'Eroare la pornirea vânzărilor'
                    : 'Eroare la oprirea vânzărilor',
                  text: errorMsg
                })
              }
            })
          } catch (error) {
            console.error(error)
            swal({
              icon: 'error',
              title: 'Eroare neașteptată',
              text: error.message || 'A apărut o eroare.'
            })
          }
        },
        async checkCompany () {
          console.log('Verificăm compania:', this.selectedLocation)

          try {
            const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/company?externalCompanyId=${encodeURIComponent(this.companyID)}`

            const response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                name: this.selectedLocation.inv_company_name || this.selectedLocation.name,
                vatNumber: this.selectedLocation.inv_fiscal_code,
                address: `${this.selectedLocation.inv_address} ${this.selectedLocation.inv_city} ${this.selectedLocation.inv_county}`,
                city: this.selectedLocation.inv_city,
                country: this.selectedLocation.inv_county,
                phone: this.selectedLocation.inv_phone,
                email: this.selectedLocation.email || '',
                inv_bank_account: this.selectedLocation.inv_bank_account || '',
                inv_bank: this.selectedLocation.inv_bank || '',
                inv_bank_branch: this.selectedLocation.inv_bank_branch || '',
                externalCompanyId: this.companyID
              })
            })

            const responseData = await response.json()

            if (!response.ok) {
              throw new Error(responseData.error || responseData.message || 'Compania nu există')
            }

            console.log('Compania există deja:', responseData)
            return responseData
          } catch (error) {
            console.error('Error checking company:', error)
            swal({
              title: 'Eroare!',
              text: error.message || 'A apărut o eroare la verificarea companiei.',
              type: 'error',
              timer: 2500,
              showConfirmButton: false
            })
            throw error
          }
        },
        async getSeries (vatNumber = null) {
          if (!this.companyID) {
            console.error('Missing company for fetching series.')
            return
          }

          try {
            // construim body-ul dinamic
            const bodyData = {
              externalCompanyId: this.companyID
            }
            if (vatNumber) {
              bodyData.vatNumber = vatNumber
            }

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(bodyData)
            })

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`)
            }

            const data = await response.json()
            this.tableDataSeries = (data.series || []).map(serie => {
              let readableTip = ''
              switch (serie.tip) {
                case 'nir': readableTip = 'NIR'; break
                case 'bon_casare': readableTip = 'Bon casare'; break
                case 'nota_de_consum': readableTip = 'Nota de consum'; break
                case 'bon_consum': readableTip = 'Bon consum'; break
                case 'bon_transfer': readableTip = 'Bon de transfer'; break
                case 'bon_productie': readableTip = 'Bon de productie'; break
                case 'inventar': readableTip = 'Inventar'; break
                case 'invoice': readableTip = 'Invoice'; break
                case 'proforma': readableTip = 'Proforma'; break
                case 'aviz': readableTip = 'Aviz'; break
                case 'order': readableTip = 'Order'; break
                default: readableTip = serie.tip
              }

              return {
                ...serie,
                tip: readableTip
              }
            })
          } catch (error) {
            console.error('Error fetching series:', error)
          }
        },
        async handleDeleteGestiune (row) {
          if (!row._id) {
            console.error('Lipsește ID-ul gestiunii pentru ștergere.')
            return
          }

          swal({
            title: 'Ești sigur că vrei să ștergi această gestiune?',
            text: 'Această acțiune nu poate fi anulată!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge!',
            cancelButtonText: 'Anulează'
          }).then(async (result) => {
            if (!result) return // dacă apasă pe Anulează => stop

            // verificăm dacă e default și mai există gestiuni
            if (this.isDefaultForLocation(row._id, row.externalLocationId)) {
              const gestiuniRamase = this.tableData.filter(g =>
                g.externalLocationId === row.externalLocationId &&
                g._id !== row._id
              )

              if (gestiuniRamase.length > 0) {
                await swal({
                  title: 'Atenție!',
                  text: 'Această gestiune este setată ca default. Selectează mai întâi o altă gestiune default pentru această locație.',
                  type: 'warning',
                  confirmButtonText: 'OK'
                })
                return
              }
            }

            try {
              swal({
                type: 'info',
                title: 'Se șterge gestiunea...',
                text: 'Vă rugăm să așteptați.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false
              })

              const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'gestiune',
                  id: row._id,
                  externalCompanyId: this.companyID
                })
              })

              if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

              const data = await response.json()
              console.log('Gestiunea a fost ștearsă cu succes:', data)

              swal.close()

              swal({
                title: 'Succes',
                text: 'Gestiunea a fost ștearsă cu succes.',
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              })

              // dacă era default și nu mai există alte gestiuni => setăm default null
              if (this.isDefaultForLocation(row._id, row.externalLocationId)) {
                const gestiuniRamase = this.tableData.filter(g =>
                  g.externalLocationId === row.externalLocationId &&
                  g._id !== row._id
                )

                if (gestiuniRamase.length === 0) {
                  this.modifyGestiune({
                    gestiuneCompanyId: row.externalCompanyId,
                    gestiuneIdDefault: null,
                    companyId: this.companyID,
                    locationId: row.externalLocationId
                  }, () => {
                    this.fetchGestiuni()
                    this.$emit('fetchLocation')
                  })
                } else {
                  this.fetchGestiuni()
                  this.$emit('fetchLocation')
                }
              }

              this.fetchGestiuni()
              this.$emit('fetchLocation')
            } catch (error) {
              swal.close()
              console.error('Eroare la ștergerea gestiunii:', error)

              swal({
                title: 'Eroare',
                text: error.message || 'A apărut o eroare la ștergerea gestiunii.',
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              })
            }
          })
        },
        async handleDeleteSeries (id) {
          if (!id) {
            console.error('Missing series ID for deletion.')
            return
          }

          swal({
            title: 'Ești sigur că vrei să ștergi seria?',
            text: 'Această acțiune nu poate fi anulată!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge!',
            cancelButtonText: 'Anulează'
          }).then(async (result) => {
            if (!result) return

            try {
              const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'series',
                  id: id,
                  externalCompanyId: this.companyID
                })
              })

              if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

              const data = await response.json()
              console.log('Series deleted successfully:', data)

              swal({
                title: 'Succes',
                text: 'Seria a fost ștearsă cu succes.',
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              })

              this.getSeries()
            } catch (error) {
              console.error('Error deleting series:', error)

              swal({
                title: 'Eroare',
                text: error.message || 'A apărut o eroare la ștergerea seriei.',
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              })
            }
          })
        },
        async addBankAccount () {
          this.bankAccounts.push({ ...this.newAccount })

          this.newAccount = { iban: '', bank: '', currency: 'RON', swift: '' }
          this.closeBankModal()
        },
        async deleteBankAccount (row) {
          this.bankAccounts = this.bankAccounts.filter(account => account !== row)
        }
      }
    }
  </script>

<style scoped>
.default-label {
  background-color: orange;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  margin-left: 8px;
  border-radius: 6px;
  font-weight: bold;
  display: inline-block;
}
a.btn.delete {
  width: auto;
}
a.btn.delete.mar-rt-10.disabled {
    width: auto;
    border-color: #FF0D19;
}
.form-check {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}
.spv-expire-box {
  margin-top: 8px;
}
.btn-primary {
  padding: 6px 50px;
}
.spv-enroll-btn {
  min-width: 190px;
}
.spv-enroll-btn[disabled],
.spv-enroll-btn:disabled {
  opacity: 0.45;
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
  cursor: not-allowed;
  box-shadow: none;
}
.spv-enroll-hint {
  margin: 10px 0 0;
  font-size: 12px;
  color: #6c757d;
}
.spv-expire-box small {
  display: inline-block;
  padding: 6px 10px;
  background-color: #f8f9fa;
  border-left: 4px solid #17a2b8;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}
.left-buttons {
display: flex;
}
.spv-error-box {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff5f5;
  border-left: 4px solid #dc3545;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #b02a37;
  display: inline-block;
}
.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}
.badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: #fff;
  transition: all 0.2s ease-in-out;
}

/* Verde - activ */
.badge-success {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  box-shadow: 0 3px 8px rgba(40, 167, 69, 0.35);
}

/* Galben - lipsă token */
.badge-warning {
  background: linear-gradient(135deg, #ffb300, #ff8f00);
  box-shadow: 0 3px 8px rgba(255, 179, 0, 0.35);
}
.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.info-text {
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementSettings.vue